import React, { useEffect, useMemo, useState } from "react";
import { useAccount, useContractRead } from "wagmi";
import { abi } from "./contract";
import BigNumber from "bignumber.js";
import useCurrentChain from "../hooks/useCurrentChain";
import config from "../config";

interface StakerInfo {
  stakedAmount: Number;
  stakingStartTime: BigNumber;
  lastClaimTime: BigNumber;
  rewards: BigNumber;
  vestingPeriod: BigNumber;
}
const StakedBal = () => {
  const [bal, setBal] = useState("");
  const { address } = useAccount();
  const chain = useCurrentChain();

  const { data, isRefetching, refetch, error } = useContractRead({
    address: config.stakingContract[chain.id],
    abi,
    functionName: "stakers",
    args: [address],
    chainId: chain.id,
    // enabled: true,
    // cacheOnBlock: true,
    // watch: true,
  });

  useEffect(() => {
    if (data !== undefined) {
      var response = data as StakerInfo;
      console.log("data:", data);
      console.log("address:", address);
      console.log("error", error);
      //check if amount is a nullable BIGint[] value
     const amount = Number(response.stakedAmount).toLocaleString();
      //const amount = (data as BigNumber[] || undefined)[0]?.toString() ?? "0"; // Convert BigNumber to string for display
      setBal(amount);
    } else {
      console.log("no data:", data);
      console.log("no address:", address);
      console.log("no error", error);
    }
  }, [data, address, error]);

  if (isRefetching) return <div>Refetching data...</div>;

  return <span className="text-[#fff]">{bal ? ` ${bal}` : "0"}</span>;
};

export default StakedBal;
